module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("37jb3"))).then(() => parcelRequire('2KbAe'));